// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"30a51054","247":"031a2d3c","268":"68ba7494","312":"09be4c09","344":"3b35a470","451":"47815e05","488":"c483aa37","627":"37f78153","653":"3806de04","834":"7c80aa2f","849":"ace739b1","867":"156db249","923":"0098e25b","938":"772928d9"}[chunkId] + ".chunk.js";
};